import { useState, useEffect } from 'react';
import { useMembers } from '../hooks/usePunishments';

interface MemberSelectorProps {
  guildId: string;
  selectedMemberId: string;
  onSelectMember: (memberId: string) => void;
}

export default function MemberSelector({ guildId, selectedMemberId, onSelectMember }: MemberSelectorProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const { data: members, isLoading } = useMembers(guildId, searchQuery);

  const selectedMember = members?.find((m) => m.id === selectedMemberId);

  useEffect(() => {
    // 검색어가 변경되면 드롭다운 열기
    if (searchQuery) {
      setIsOpen(true);
    }
  }, [searchQuery]);

  const handleSelectMember = (memberId: string) => {
    onSelectMember(memberId);
    setIsOpen(false);
    setSearchQuery('');
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={selectedMember ? `${selectedMember.username}#${selectedMember.discriminator}` : searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onFocus={() => setIsOpen(true)}
        placeholder="멤버 이름으로 검색..."
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute z-20 w-full mt-2 bg-white rounded-lg border border-gray-200 shadow-lg max-h-60 overflow-y-auto">
            {isLoading ? (
              <div className="px-4 py-3 text-sm text-gray-600">검색 중...</div>
            ) : members && members.length > 0 ? (
              members.map((member) => (
                <button
                  key={member.id}
                  type="button"
                  onClick={() => handleSelectMember(member.id)}
                  className="flex items-center space-x-3 w-full px-4 py-3 hover:bg-gray-50 transition-colors text-left"
                >
                  {member.avatar ? (
                    <img
                      src={`https://cdn.discordapp.com/avatars/${member.id}/${member.avatar}.png`}
                      alt={member.username}
                      className="w-8 h-8 rounded-full"
                    />
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-gradient-to-r from-[#FF7A7A] to-[#DD8DFF] flex items-center justify-center text-white font-bold">
                      {member.username.charAt(0).toUpperCase()}
                    </div>
                  )}
                  <div>
                    <div className="font-medium text-gray-900">
                      {member.nick || member.username}
                    </div>
                    <div className="text-xs text-gray-500">
                      {member.username}#{member.discriminator}
                    </div>
                  </div>
                </button>
              ))
            ) : (
              <div className="px-4 py-3 text-sm text-gray-600">
                {searchQuery ? '검색 결과가 없습니다' : '멤버를 검색하세요'}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
